import * as React from 'react';
import { cancelButton } from '../../themes/styles';
import Button from '@material-ui/core/Button';
import Dialog from '../BuildingBlocks/Dialogs/DialogStyleOne/Dialog';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  cancelButton: { ...(cancelButton as object), marginRight: 16 },
}));

export default function DeleteConfirmation(props) {
  const classes = useStyles();
  const { open, deleteLineClick, handleClose, lineName } = props;

  const onClose = (refresh = false) => {
    handleClose(refresh);
  };

  const header = `Delete line: ${lineName}`;

  const content = (
    <Typography>
      Do you want to delete line <b>{lineName} </b> ? Don't worry, you can
      always create another line at any time.
    </Typography>
  );

  const actions = (
    <>
      <Button
        className={classes.cancelButton}
        autoFocus
        onClick={() => onClose()}
      >
        Cancel
      </Button>
      <Button color="primary" variant="contained" onClick={deleteLineClick}>
        Delete
      </Button>
    </>
  );
  return (
    <Dialog open={open} title={header} content={content} actions={actions} />
  );
}
